import { localeList } from "./localeList"

const defaultLangList = () => {
  return Object.keys(localeList)
}

export default defaultLangList
